import { CALL_API, getJSON } from 'redux-api-middleware';
import { normalize } from 'normalizr';
import { products } from 'schemas';
import endpoints from 'api/endpoints';
import types from '../types';

export default data => {console.log(data); return {
  [CALL_API]: {
    endpoint: endpoints.PRODUCTS_API,
    method: 'POST',
    body: JSON.stringify(data),

    headers: {
      'Content-Type': 'application/json',
    },

    types: [
      types.POST_PRODUCT_REQUEST,

      {
        type: types.POST_PRODUCT_SUCCESS,
        payload: (action, state, res) => getJSON(res)
          .then(json => normalize(
            json,
            products.productSchema,
          )),
      },

      types.POST_PRODUCT_FAILURE,
    ],
  },
}};



// WEBPACK FOOTER //
// ./src/api/products/actions/postProduct.js